<template>
	<div>
		<div class="pd25">
			<div class="hd">
				<div class="title">验证码</div>
				<div class="hdsub">验证码已发送至<span class="phoneNum">{{userinfo.mobile}}</span></div>
			</div>
			<van-field
					v-model="smsCode"
					center
					clearable
					placeholder="4位验证码">
				<van-button :class="{disableBtn: smsBtnStatus}" slot="button" size="small" @click="handleSendSmsCode" type="primary" :disabled="smsBtnStatus">{{smsBtnText}}</van-button>
			</van-field>

			<div class="loginBtn">
				<van-button type="warning" :disabled="disabledStatus" size="large" @click="handlerLoginBySms">登录</van-button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import _ from 'lodash';
import { navigationTo } from '../lib/util.js';

export default {
  name: 'mobile',
  data() {
    return {
      smsCode: '',
      tipsMsg: '',
      smsBtnStatus: false,
      smsBtnText: '获取验证码'
    }
  },
  computed: {
    ...mapState('login', ['userinfo', 'smsInfo', 'redirectUrl']),
    disabledStatus() {
      return !(this.smsCode && /^\d{4}$/g.test(this.smsCode) && _.get(this.smsInfo, 'mfaTempToken'));
    }
  },
	  created() {
    this.setSmsInfo();
	  },
  methods: {
    ...mapActions('login', ['sendSmsCode', 'loginBySms']),
    ...mapMutations('login', ['setSmsInfo']),
    initSmsinfo() {
      this.tipsMsg = '';
      this.smsBtnText = '获取验证码';
      this.smsBtnStatus = false;
    },
    changeBtnTxt() {
      const self = this;
      const num = 60;
      function next(num) {
        --num;
        if (!self.smsBtnStatus) {
          return;
        }
        if (num === 0) {
          self.smsBtnText = '重新获取';
          self.smsBtnStatus = false;
          return;
        }
        setTimeout(() => {
          self.smsBtnText = `重新获取(${num})`;
          if (!self.smsBtnStatus) {
            self.smsBtnText = '重新获取';
          }
          next(num);
        }, 1000)
      }
      next(num);
    },
    handleSendSmsCode() {
      this.smsCode = '';
      const mfaTempToken = _.get(this.smsInfo, 'mfaTempToken') || _.get(this.userinfo, 'mfaTempToken');
      this.smsBtnStatus = true;
      // this.smsBtnText = '验证码发送中...';
      this.smsBtnText = '获取验证码';
      this.tipsMsg = '';
      this.changeBtnTxt();
      this.sendSmsCode({ mfaTempToken }).then(res => {
        this.tipsMsg = '验证码已发送至您手机，30分钟内输入有效';
      }).catch(err => {
        this.initSmsinfo();
      });
    },
    handlerLoginBySms() {
      const code = this.smsCode;
      const { mfaTempToken } = this.smsInfo;
      this.loginBySms({ mfaTempToken, code }).then(res => {
        if (res.ssoToken) {
          return navigationTo(this.redirectUrl, res.ssoToken);
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
	.disableBtn {
		color: #E5E5E5;
		border: 1px solid #E5E5E5;
	}
	.van-cell {
		padding-left: 0;
		padding-right: 0;
	}
	.van-cell:not(:last-child)::after {
		margin-left: 0;
	}
	.hd {
		padding-top: 15px;
		padding-bottom: 3px;
	}
	.title {
		font-size: 14px;
	}
	.hdsub {
		font-size: 12px;
		color: #999;
	}
	.loginBtn {
		padding: 24px 0 16px;
	}
	.phoneNum {
		color: #333;
	}
</style>
